const findNextValidStep = ({ steps, currentStep }) => {
  if (!steps) {
    return 0;
  } else if (currentStep === steps.length) {
    return currentStep + 1;
  } else {
    const i = steps.slice(currentStep + 1).findIndex(({ skip }) => !skip);
    return i === -1 ? steps.length : currentStep + 1 + i;
  }
};

const findPreviousStep = ({ steps, currentStep }) => {
  if (!steps || currentStep === 0) {
    return 0;
  } else {
    const i = steps
      .slice(0, currentStep)
      .reverse()
      .findIndex(({ skip }) => !skip);
    return i === -1 ? 0 : currentStep - 1 - i;
  }
};

export { findNextValidStep, findPreviousStep };
